import { Typography } from "@material-ui/core";
import AddBoxOutlinedIcon from "@material-ui/icons/AddBoxOutlined";
import ColorButton from "components/common/ColorButton";
import React from "react";

export default function AddRowButton({ onClick, disabled }) {
  return (
    <ColorButton
      variant="outlined"
      color="info"
      style={{ width: 260 }}
      onClick={onClick}
      disabled={disabled}
    >
      <AddBoxOutlinedIcon />
      <Typography
        style={{ marginLeft: 10, fontWeight: "bold" }}
        variant="button"
      >
        Add Row
      </Typography>
    </ColorButton>
  );
}
